import * as PIXI from "pixi.js";
import { Assets } from "pixi.js";
import L from "leaflet";
const drawMarker = ({
  m,
  container,
  project,
  pixiOverlay,
  colorMode,
  editable,
  showLabel,
  elementSelected,
  handleUpdatePositionElement,
  onClick,
  map,
  rulerMode,
  spriteByIdRef,
  explosionsRef,
  configElementDataMap,
  theme,
  labelTexture,
  editMode,
}) => {
  if (!m?.iconId || !m?.baseIcon) return;

  const { utils } = pixiOverlay;
  const texture = Assets.get(m.iconId);
  const markerTextureLight = Assets.get("marker_circle_light");
  const markerTextureDark = Assets.get("marker_circle_dark");
  const markerTextureTransparent = Assets.get("marker_circle_transparent");

  if (
    !(
      texture &&
      markerTextureLight &&
      markerTextureDark &&
      markerTextureTransparent
    )
  )
    return;

  const node = new PIXI.Container();

  if (!(m?.position?.[0] && m?.position?.[1])) return;
  const point = project(L.latLng(...m?.position));

  node.position.set(point.x, point.y);

  node.markerId = m.id ?? m.tempId;

  /* -- sprite marcador -- */
  const circleTexture =
    colorMode === "light" || (m.severity == 5 && !editable)
      ? markerTextureLight
      : markerTextureDark;

  const circle = new PIXI.Sprite(circleTexture);
  const circleBase = new PIXI.Sprite(markerTextureTransparent);
  circle.tint =
    m.severity == 5 && !editable
      ? PIXI.utils.string2hex(theme.palette.color?.zabbixSeverty?.disaster)
      : 0xffffff;

  circleBase.tint = editMode
    ? PIXI.utils.string2hex(theme.palette.color?.zabbixSeverty?.selected)
    : m.tint
    ? PIXI.utils.string2hex(m.tint)
    : 0xffffff;
  circle.anchor.set(0.5);
  circleBase.anchor.set(0.5);
  /* -- sprite ícone -- */
  const sprite = new PIXI.Sprite(texture);

  // Lida com mudança da cor do icone no modo claro e escuro
  // Altera apenas SVG, para não alterar icones PNG com cores adicionados pelo usuário
  if (texture.baseTexture?.resource?.src?.includes("svg"))
    sprite.tint =
      !editMode && m.severity == 5
        ? "#e6e6e6"
        : colorMode === "light"
        ? "#4e4e4e"
        : "#e6e6e6";
  sprite.anchor.set(0.5);
  sprite.width = 40;
  sprite.height = 40;

  sprite.baseScale = sprite.scale.clone();

  node.zIndex = 100;
  node.addChild(circle);
  node.addChild(circleBase);
  node.addChild(sprite);

  if (showLabel) {
    const titleSprite = new PIXI.Sprite(labelTexture);
    titleSprite.anchor.set(0.5);
    titleSprite.y = -55;
    node.addChild(titleSprite);
  }

  node.eventMode = "static";
  node.cursor = "pointer";

  let dragging = false;
  let dragOffset = { x: 0, y: 0 };

  if (
    editable &&
    (m?.id === elementSelected?.id || m?.id === elementSelected?.tempId)
  ) {
    const onDragStart = (e) => {
      if (rulerMode) return;

      e.stopPropagation();
      dragging = true;

      node.alpha = 0.6;
      map.dragging.disable();

      const localPosition = node.parent.toLocal(e.global);

      dragOffset.x = node.x - localPosition.x;
      dragOffset.y = node.y - localPosition.y;

      const stage = node.stage || node.parent;

      stage.on("pointermove", onDragMove);
      stage.on("pointerup", onDragEnd);
      stage.on("pointerupoutside", onDragEnd);
    };

    const onDragMove = (e) => {
      if (!dragging) return;

      const localPosition = node.parent.toLocal(e.global);
      node.position.set(
        localPosition.x + dragOffset.x,
        localPosition.y + dragOffset.y
      );
    };

    const onDragEnd = () => {
      if (!dragging) return;

      dragging = false;
      node.alpha = 1;
      map.dragging.enable();

      const newPoint = { x: node.position.x, y: node.position.y };
      const newLatLng = utils.layerPointToLatLng(newPoint);
      handleUpdatePositionElement(null, {
        lat: newLatLng.lat,
        lng: newLatLng.lng,
      });

      const stage = node.stage || node.parent;
      stage.off("pointermove", onDragMove);
      stage.off("pointerup", onDragEnd);
      stage.off("pointerupoutside", onDragEnd);
    };

    node.on("pointerdown", onDragStart);
  }

  node.on("pointerdown", (e) => {
    if (!dragging && !rulerMode) onClick(e, m);
  });

  container.addChild(node);

  const baseCircleRadius = (circle.width ?? 0) / 2;
  const baseSpriteRadius = (sprite.width ?? 0) / 2;
  const baseRadiusPx = Math.max(baseSpriteRadius, baseCircleRadius);

  // Guarda referência dos sprites
  spriteByIdRef.current.set(m.id ?? m.tempId, {
    circle,
    circleBase,
    sprite,
    baseRadiusPx,
  });

  const configEl = configElementDataMap?.get(m.id);
  if (configEl?.severity > 1 && !editable) {
    const explosion = new PIXI.Sprite(markerTextureLight);
    explosion.tint = PIXI.utils.string2hex(m.tint);
    explosion.anchor.set(0.5);
    node.addChildAt(explosion, 0);

    explosionsRef.current.set(m.id, { graphic: explosion, t: 0 });
  } else {
    // Remove explosão se não tiver mais alertas críticos
    explosionsRef.current.delete(m.id);
  }
};

export default drawMarker;
